import { fetchWithRetry } from "@nervedx/shared/fetch-retry";

export type RuntimePublicConfig = {
  captchaProvider?: string;
  captchaSiteKey?: string;
  chatwootBaseUrl?: string;
  faroEnabled?: boolean;
  faroEndpoint?: string;
  controlPlaneUiUrl?: string;
};

let cachedConfig: RuntimePublicConfig | null = null;

export function getRuntimePublicConfig(): RuntimePublicConfig | null {
  return cachedConfig;
}

export function setRuntimePublicConfig(config: RuntimePublicConfig | null): void {
  cachedConfig = config;
  if (typeof window === "undefined" || !config) {
    return;
  }

  const runtimeInfo =
    ((window as unknown as Record<string, unknown>).__PLATFORM_RUNTIME_INFO__ as
      | Record<string, unknown>
      | undefined) ||
    ((window as unknown as Record<string, unknown>).__NERVEDX_RUNTIME_INFO__ as
      | Record<string, unknown>
      | undefined) ||
    {};
  runtimeInfo.publicConfig = config;
  const globalWindow = window as unknown as Record<string, unknown>;
  globalWindow.__PLATFORM_RUNTIME_INFO__ = runtimeInfo;
  globalWindow.__NERVEDX_RUNTIME_INFO__ = runtimeInfo;
}

export async function bootstrapRuntimePublicConfig(): Promise<RuntimePublicConfig | null> {
  try {
    const response = await fetchWithRetry("/api/runtime-config", {
      credentials: "include",
    });
    if (!response.ok) {
      return null;
    }
    const body = (await response.json()) as { data?: RuntimePublicConfig };
    const config = body.data ?? null;
    setRuntimePublicConfig(config);
    return config;
  } catch {
    return null;
  }
}
